module.exports = __webpack_public_path__ + "img/register-footer-bg.d2d9f828.svg";